interface PublicConfig {
  googleMapsApiKey?: string;
  googleClientId?: string;
  googleAnalyticsCode?: string;
  recaptchaSiteKey?: string;
}

const config: PublicConfig = typeof window === 'undefined' ? {} :
  ((window as Window & { KAILO_PUBLIC_CONFIG?: PublicConfig }).KAILO_PUBLIC_CONFIG || {});

export const publicConfig = {
  googleMapsApiKey: config.googleMapsApiKey || '',
  googleClientId: config.googleClientId || '',
  googleAnalyticsCode: config.googleAnalyticsCode || '',
  recaptchaSiteKey: config.recaptchaSiteKey || ''
};
